const binding = { modules: {}, dataActions: {} };

    (binding.modules['phibro-c-cookie-compliance'] = {
        c: () => require('partner/modules/phibro-c-cookie-compliance/phibro-c-cookie-compliance.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'phibro-c-cookie-compliance',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/phibro-c-cookie-compliance'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|phibro-c-cookie-compliance|phibro-c-cookie-compliance'] = {
                c: () => require('partner/modules/phibro-c-cookie-compliance/phibro-c-cookie-compliance.view.tsx'),
                cn: '__local__-__local__-phibro-c-cookie-compliance'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };